@if (isInitialized) {
  <oe-chart [title]="component.alias">
    <scheduleChart [isOnlyChart]="true">
    </scheduleChart>
  </oe-chart>
}
